
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";


export const UserRoute = ({ element }) => {
    const { user } = useAuth();
    return user?.role === "user" ? element : <Navigate to="/" />;
};
